import { PublicClientApplication, type Configuration, type RedirectRequest } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;
const redirectUri = (import.meta.env.VITE_ENTRA_REDIRECT_URI as string) ?? window.location.origin;
export const apiScope = import.meta.env.VITE_API_SCOPE as string;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: [apiScope, 'openid', 'profile', 'email'],
};

export const apiTokenRequest = { scopes: [apiScope] };
